import { OCC_CART_ID_CURRENT, StateUtils } from '@spartacus/core';
import { EntriesState } from '../../../../../core/features/store/base-feature-state';
import { Cart, CartType } from '../../../../../core/model/cart.model';
import { cartWithOrderEntryIds } from '../../../../../shared';
import { CartEntryActionTypes } from '../actions/cart-entry.action';
import { CartActionTypes } from '../actions/cart.action';
import { CartEntryFullPalletNoteActionTypes, CartEntryPalletFlagsActionTypes } from '../actions/cart.actions';
import { CartActions } from '../actions/index';
import { reducer as cartEntryReducer } from './cart-entry.reducer';

export const cartInitialState: Cart | undefined = undefined;

export function cartReducer(
  state = cartInitialState,
  action:
    | CartActions.LoadCartSuccess
    | CartActions.UpdateCartEntrySuccess
    | StateUtils.LoaderAction
    | CartActions.CartEntryPalletFlagsActions
    | CartActions.CartEntryFullPalletNoteActions
): Cart {
  switch (action.type) {
    case CartActionTypes.LoadCartSuccess:
      return cartWithOrderEntryIds(action.payload.cart, state);
    case CartEntryActionTypes.RemoveCartEntrySuccess:
    case CartEntryActionTypes.RemoveCartEntriesSuccess:
    case CartEntryActionTypes.RemoveAllCartEntriesSuccess:
    case CartEntryActionTypes.UpdateCartEntrySuccess:
    case CartEntryPalletFlagsActionTypes.UpdateCartEntryPalletFlagsSuccess:
    case CartEntryFullPalletNoteActionTypes.AddCartEntryFullPalletNoteSuccess:
    case CartEntryFullPalletNoteActionTypes.RemoveCartEntryFullPalletNoteSuccess:
      return state?.entries
        ? {
            ...state,
            entries: cartEntryReducer(state.entries, action),
          }
        : state;
  }
  return state;
}

function activeInitialStateFactory(): EntriesState<string> {
  return Object.values(CartType).reduce((state, cartType) => ({ ...state, [cartType]: OCC_CART_ID_CURRENT }), {});
}

export const activeInitialState: EntriesState<string> = activeInitialStateFactory();

export function activeReducer(state = activeInitialState, action: CartActions.CartActions): EntriesState<string> {
  switch (action.type) {
    case CartActionTypes.LoadCartSuccess:
      if (action?.payload?.extraData?.active) {
        return {
          ...state,
          [action.payload.cartType]: action.meta.entityId as string,
        };
      } else {
        return state;
      }
    case CartActionTypes.SetActiveCartId:
      return {
        ...state,
        [action.payload.cartType]: action.payload.cartId,
      };
    case CartActionTypes.RemoveCart:
      if (action.payload?.cartId === state[action.payload.cartType]) {
        return {
          ...state,
          [action.payload.cartType]: OCC_CART_ID_CURRENT,
        };
      }
      return state;
    case CartActionTypes.ClearCartsState:
      return activeInitialState;
  }
  return state;
}
